import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./Header.css";
import logo from "../assets/icons/dpboss.png";
import { AppContext } from "../context/AppContext";

export default function Header({ onMenuClick, isAccountActive }) {
  const navigate = useNavigate();
  const { user, loading } = useContext(AppContext);

  const walletBalance = user?.walletBalance ?? 0;

  return (
    <header className="main-header">
      {/* LEFT: MENU + LOGO + TITLE */}
      <div className="menu-logo">
        <button
          className="menu-pill"
          onClick={onMenuClick}
          aria-label="Open menu"
        >
          <span className="burger" />
        </button>

        <img src={logo} alt="Dp Boss" className="logo" />

        {/* <div className="game-title">
          <span className="super-text">Super</span>
          <span className="kalyan-bg">Kalyan</span>
        </div> */}
      </div>

      {/* RIGHT: WALLET + NOTIFICATION */}
      {isAccountActive && (
        <div className="header-icons">
          {/* WALLET */}
          <button
            className="icon-btn wallet-btn"
            onClick={() => navigate("/passbook")}
            aria-label="Wallet"
          >
            <span className="icon-wallet" />
            <span className="wallet-balance">
              {loading ? "…" : walletBalance}
            </span>
          </button>

          {/* NOTIFICATIONS */}
          {/* <button
            className="icon-btn"
            onClick={() => navigate("/notifications")}
            aria-label="Notifications"
          >
            <span className="icon-bell" />
          </button> */}
        </div>
      )}
    </header>
  );
}